import { node } from "prop-types";
import React, { useRef } from "react";

import styled from "styled-components/macro";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";

import { useDirection } from "../stateHooks";

import Dismiss from "./Dismiss";

const Card = ({ children }) => {
  const cardRef = useRef();
  const isHoverFocused = Boolean(useIsHoverFocused(cardRef));
  const direction = useDirection();
  const { ID, backgroundColor, isDismissible } = useCategoryCardContext();

  return (
    <CardWrapper
      ref={cardRef}
      key={ID}
      backgroundColor={backgroundColor}
      $direction={direction}
      data-cy="DashboardCards_CategoryCard"
    >
      {isDismissible && (
        <FnrOpacityToggle show={isHoverFocused}>
          <Dismiss />
        </FnrOpacityToggle>
      )}

      {children}
    </CardWrapper>
  );
};

Card.propTypes = { children: node };

export default Card;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  gap: 0.5rem;
  padding: 1.5rem;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  position: relative;
`;
